<template>
  <div></div>

</template>

<script>
import {downloadCounter} from "../../request/API";

export default {
  name: "statistics",
  props:{},
  components:{},
  data(){
    return {

    }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
  },
  watch:{

  },
  created() {
    let channel_code = sessionStorage.getItem('channel_code')
    downloadCounter({from:'homepage',channel_code:channel_code || ''})
    if (this._isMobile()) {
      location.replace(`https://m.pxb7.com`)
    }else{
      this.$router.replace('/')
    }

  },
  mounted() {

  }
}
</script>

<style scoped lang="less">

</style>
